import { supabase } from "@/integrations/supabase/client";
import { getClientId, getSessionId } from "@/lib/analytics/clientId";
import { trackEvent } from "@/lib/analytics/ga";

export type AdPlacement =
  | "top-strip"
  | "in-article-top"
  | "in-article-body"
  | "in-article-shortcode"
  | "sidebar"
  | "car-detail-block"
  | "car-detail-cta"
  | "service-page"
  | "homepage"
  | "unknown";

const impressionSeen = new Set<string>();

function pageInfo() {
  if (typeof window === "undefined") return { path: null, type: null };
  const path = window.location.pathname;
  let type: string = "other";
  if (path === "/") type = "home";
  else if (path.startsWith("/nyheder")) type = "news";
  else if (path.startsWith("/biler")) type = "car";
  else if (path.startsWith("/magasin")) type = "magazine";
  else if (path.startsWith("/services") || path.startsWith("/anbefalinger")) type = "service";
  else if (path.startsWith("/admin")) type = "admin";
  return { path, type };
}

async function insertEvent(payload: {
  event_type: "impression" | "click";
  affiliate_id: string;
  placement: AdPlacement | string;
}) {
  try {
    const { path, type } = pageInfo();
    await supabase.from("ad_events").insert({
      event_type: payload.event_type,
      affiliate_id: payload.affiliate_id,
      placement: payload.placement || "unknown",
      page_path: path,
      page_type: type,
      client_id: getClientId() || null,
      session_id: getSessionId() || null,
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
      referrer: typeof document !== "undefined" ? document.referrer || null : null,
    });
  } catch {
    /* ignore */
  }
}

export function trackAdImpression(affiliateId: string, placement: AdPlacement | string) {
  if (!affiliateId) return;
  const key = `${getSessionId()}::${affiliateId}::${placement}`;
  if (impressionSeen.has(key)) return;
  impressionSeen.add(key);
  void insertEvent({ event_type: "impression", affiliate_id: affiliateId, placement });
  trackEvent("ad_impression", { affiliate_id: affiliateId, placement: placement || "unknown" });
}

export function trackAdClick(affiliateId: string, placement: AdPlacement | string) {
  if (!affiliateId) return;
  void insertEvent({ event_type: "click", affiliate_id: affiliateId, placement });
  trackEvent("affiliate_click", { affiliate_id: affiliateId, placement: placement || "unknown" });
}
